import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import Marq2 from '../components/common/Marq2';
import { Helmet } from 'react-helmet';
import Header from '../components/home-main/Header';
import Intro from '../components/home-main/Intro';
import Portfolio from '../components/home-main/Portfolio';
import Services from '../components/home-main/Services';
import Clients from '../components/home-main/Clients';
import Contact from '../components/home-main/Contact';
import Feat from '../components/home-main/Feat';
import Marq from '../components/home-main/Marq';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';

import { useGSAP } from '@gsap/react';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function HomeMain() {
  const main = useRef();

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        script.onload = () => {
          resolve(true);
        };

        script.onerror = () => {
          reject(new Error(`Failed to load ${src}`));
        };

        document.body.appendChild(script);
      });
    };

    // Load ScrollSmoother.min.js first
    loadScript('/assets/js/gsap.min.js')
      .then(() => {
        loadScript('/assets/js/ScrollSmoother.min.js');
      })
      .then(() => {
        // Once ScrollSmoother.min.js is loaded, load smoother-script.js
        return loadScript('/assets/js/smoother-script.js');
      })
      .catch((error) => {
        console.error(error.message);
      });

    // // Cleanup function
    // return () => {
    //   document.body.removeChild(script);
    // };
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      new WOW.WOW({
        animateClass: 'animated',
        offset: 0,
        mobile: true,
      }).init();
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Hanzol – Agência de publicidade</title>
        <meta name="description" content="A Hanzol é uma agência de marketing e publicidade que conecta estratégia, conteúdo, campanhas e execução dentro da mesma operação. Atendemos marcas que querem crescer com direção." />
        <meta name="keywords" content="agência de marketing, publicidade, branding, tráfego pago, gestão de redes sociais, SEO, marketing digital, Belo Horizonte, BH" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Hanzol – Agência de publicidade" />
        <meta property="og:description" content="Estratégia, conteúdo e execução para marcas que querem crescer com direção. Conheça a Hanzol." />
        <meta property="og:image" content="/assets/imgs/isotipo-light.png" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Hanzol" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Hanzol – Agência de publicidade" />
        <meta name="twitter:description" content="Estratégia, conteúdo e execução para marcas que querem crescer com direção." />
        <meta name="twitter:image" content="/assets/imgs/isotipo-light.png" />
        <link rel="icon" href="/assets/imgs/favicon.png" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.png" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap" />
        <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap" />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script defer src="/assets/js/gsap.min.js"></script>
        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <Header />
              <Intro />
              <Marq />
              <Services />
              <Portfolio />
              <Feat />
              <Clients />
              <Contact />
              <Marq2 />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
